module.exports = __webpack_public_path__ + "img/48.20452efb.png";